import React, { useEffect, useState, useContext } from 'react';
import QRCode from 'react-qr-code';
import toastError from '../../toasts/toastError';

import { Dialog, DialogContent, Typography, useTheme } from '@mui/material';

import { i18n } from '../../translate/i18n';
import api from '../../services/api';

import { AuthContext } from '../../context/Auth/AuthContext';
import { getStyled } from './styles';

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [qrCode, setQrCode] = useState('');
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;

    const onWhatsappData = (data) => {
      if (data.action === 'update' && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === 'update' && data.session.qrcode === '') {
        onClose();
      }
    };
    socket.on(`company-${companyId}-whatsappSession`, onWhatsappData);

    return () => {
      socket.off(`company-${companyId}-whatsappSession`, onWhatsappData);
    };
  }, [whatsAppId, onClose, socket, user]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' scroll='paper'>
      <DialogContent sx={theme.custom.dialogColor}>
        <Typography sx={classes.text} gutterBottom>
          {i18n.t('qrCode.message')}
        </Typography>
        <div style={classes.root}>
          {qrCode ? (
            <QRCode
              value={qrCode}
              size={300}
              style={{ backgroundColor: 'white', padding: '5px' }}
            />
          ) : (
            <span>Aguardando pelo QR Code</span>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
